import { observer } from "mobx-react-lite";
import { MemItSidePanelView } from "@/components/mem-it/MemItSidePanelView";
import { RedirectToActiveOrNewSession } from "@/components/mem-it/RedirectToActiveOrNewSession";

export interface MemItViewRouterProps {
  sessionId?: string;
}

export const MemItViewRouter = observer<MemItViewRouterProps>(function MemItViewRouter({
  sessionId,
}) {
  if (!sessionId) {
    return <RedirectToActiveOrNewSession />;
  }

  return <MemItSidePanelView sessionId={sessionId} />;
});
